module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    on: {
      "click": function($event) {
        return _vm.$emit('click', _vm.item)
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "ssid"
  }, [_vm._v(_vm._s(_vm.item.ssid))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-591bf8c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/wifiSelect/components/WifiItem/index.vue
// module id = 830
// module chunks = 1